import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vuelidate from "vuelidate"
import VueQrcodeReader from "vue-qrcode-reader";
import VueSweetalert2 from 'vue-sweetalert2';
import VueAnalytics from 'vue-analytics'

Vue.use(Vuelidate);
Vue.use(VueQrcodeReader);
Vue.use(VueSweetalert2);

Vue.use(VueAnalytics, {
  id: 'UA-179953315-1'
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
